function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageDotsCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "message-dots-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.71355 12.9286H8.72403M13.4278 12.9286H13.4383M18.1421 12.9286H18.1526M13.4278 22.3571C18.6351 22.3571 22.8564 18.1358 22.8564 12.9286C22.8564 7.72132 18.6351 3.5 13.4278 3.5C8.22058 3.5 3.99927 7.72132 3.99927 12.9286C3.99927 14.1827 4.24413 15.3797 4.68867 16.4742C4.77374 16.6837 4.81628 16.7885 4.83526 16.8732C4.85383 16.956 4.86062 17.0173 4.86063 17.1021C4.86064 17.1889 4.84489 17.2834 4.81338 17.4725L4.19216 21.1998C4.12711 21.5901 4.09458 21.7853 4.15511 21.9264C4.20809 22.0499 4.30652 22.1483 4.43003 22.2013C4.57116 22.2618 4.76632 22.2293 5.15664 22.1643L8.88395 21.543C9.07298 21.5115 9.16749 21.4958 9.25426 21.4958C9.33914 21.4958 9.40044 21.5026 9.48326 21.5211C9.56793 21.5401 9.67267 21.5827 9.88216 21.6677C10.9767 22.1123 12.1737 22.3571 13.4278 22.3571ZM9.23736 12.9286C9.23736 13.2179 9.00285 13.4524 8.71355 13.4524C8.42426 13.4524 8.18974 13.2179 8.18974 12.9286C8.18974 12.6393 8.42426 12.4048 8.71355 12.4048C9.00285 12.4048 9.23736 12.6393 9.23736 12.9286ZM13.9516 12.9286C13.9516 13.2179 13.7171 13.4524 13.4278 13.4524C13.1385 13.4524 12.904 13.2179 12.904 12.9286C12.904 12.6393 13.1385 12.4048 13.4278 12.4048C13.7171 12.4048 13.9516 12.6393 13.9516 12.9286ZM18.6659 12.9286C18.6659 13.2179 18.4314 13.4524 18.1421 13.4524C17.8528 13.4524 17.6183 13.2179 17.6183 12.9286C17.6183 12.6393 17.8528 12.4048 18.1421 12.4048C18.4314 12.4048 18.6659 12.6393 18.6659 12.9286Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.63429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageDotsCircle);
export default __webpack_public_path__ + "static/media/message-dots-circle.e4021e5e952f144182fadcb54856b521.svg";
export { ForwardRef as ReactComponent };